define([
	"csi/def",
	"csi/def/ActionFactory",
	"./_StateAction"
], function(def,ActionFactory,_StateAction) {

	return ActionFactory.declare("Approve", _StateAction, {
		m_tag: "Approve",

		constructor: function(obj) {
			if (!this.m_typeControl) {
				this.setMaterialIcon("check_circle");
			}
		},

		_hasStateAccess: function(/*def.Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: disable action if have a workflow
			if (!this.inherited(arguments))
				return false;

			return !this._hasAssignedWorkflow(ctx, master);
		}
	});
});